import {
  Box,
  Typography,
  Button,
  Chip,
  Menu,
  MenuItem,
  FormControl,
  Select,
  ListItemIcon,
  ListItemText,
  Divider,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  PointOfSale,
  OpenInNew,
  Close,
  Add,
  Receipt,
  ShoppingCart,
  AttachMoney,
} from '@mui/icons-material';
import { useState } from 'react';
import { useApp } from '../../context/AppContext';

const POSHeader = ({ onNewExpense, onNewSale }) => {
  const { cajaEstado, setCajaEstado } = useApp();
  const [ventaMenuAnchor, setVentaMenuAnchor] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleCajaChange = (event) => {
    setCajaEstado(event.target.value);
  };

  const handleVentaClick = (event) => {
    setVentaMenuAnchor(event.currentTarget);
  };

  const handleVentaClose = () => {
    setVentaMenuAnchor(null);
  };

  const handleVentaLibreClick = () => {
    setVentaMenuAnchor(null);
    if (onNewSale) {
      onNewSale('libre');
    }
  };

  const handleVentaProductosClick = () => {
    setVentaMenuAnchor(null);
    if (onNewSale) {
      onNewSale('productos');
    }
  };

  const cajaColor = cajaEstado === 'abierta' ? 'success' : 'error';

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
        p: 2,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      {/* Título */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PointOfSale color="primary" sx={{ fontSize: 32 }} />
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
          Punto de Venta
        </Typography>
      </Box>

      {/* Controles derechos */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        {/* Selector de estado de caja */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            p: 1,
            pr: 2,
            borderRadius: 2,
            backgroundColor: cajaEstado === 'abierta' ? 'success.light' : 'error.light',
          }}
        >
          {cajaEstado === 'abierta' ? (
            <OpenInNew sx={{ color: 'success.dark' }} />
          ) : (
            <Close sx={{ color: 'error.dark' }} />
          )}
          {!isMobile && (
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
              Caja {cajaEstado === 'abierta' ? 'Abierta' : 'Cerrada'}
            </Typography>
          )}
          <FormControl size="small" sx={{ minWidth: 100 }}>
            <Select
              value={cajaEstado}
              onChange={handleCajaChange}
              sx={{
                color: 'success.dark',
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
                '.MuiSvgIcon-root': { color: 'success.dark' },
                fontSize: '0.875rem',
              }}
              variant="standard"
              disableUnderline
            >
              <MenuItem value="abierta">
                <ListItemIcon>
                  <OpenInNew fontSize="small" color="success" />
                </ListItemIcon>
                <ListItemText>Abierta</ListItemText>
              </MenuItem>
              <MenuItem value="cerrada">
                <ListItemIcon>
                  <Close fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText>Cerrada</ListItemText>
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Botón Nuevo Gasto */}
        <Button
          variant="outlined"
          startIcon={<AttachMoney />}
          onClick={() => onNewExpense && onNewExpense()}
          sx={{
            borderColor: 'warning.main',
            color: 'warning.main',
            '&:hover': {
              borderColor: 'warning.dark',
              backgroundColor: 'warning.light',
            },
          }}
        >
          {!isMobile && 'Nuevo Gasto'}
        </Button>

        {/* Botón Nueva Venta con dropdown */}
        <Button
          variant="contained"
          startIcon={<ShoppingCart />}
          onClick={handleVentaClick}
          sx={{
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          {!isMobile ? 'Nueva Venta' : 'Venta'}
        </Button>
        <Menu
          anchorEl={ventaMenuAnchor}
          open={Boolean(ventaMenuAnchor)}
          onClose={handleVentaClose}
          PaperProps={{
            sx: { minWidth: 200 },
          }}
        >
          <MenuItem onClick={handleVentaLibreClick}>
            <ListItemIcon>
              <Receipt fontSize="small" />
            </ListItemIcon>
            <ListItemText>Venta Libre</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleVentaProductosClick}>
            <ListItemIcon>
              <ShoppingCart fontSize="small" />
            </ListItemIcon>
            <ListItemText>Venta de Productos</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default POSHeader;
